const NavbarLinks = ({ isScrolled, onNavigate }) => {
  return (
    <div
      className={`hidden lg:flex items-center gap-6 xl:gap-8 text-sm font-semibold tracking-wide ${
        isScrolled ? 'text-gray-800' : 'text-gray-600'
      }`}
    >
      <button
        onClick={() => onNavigate('features')}
        className="hover:text-[#067978] transition-colors relative group cursor-pointer"
      >
        Features
        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#067978] transition-all group-hover:w-full" />
      </button>
      <button
        onClick={() => onNavigate('how-it-works')}
        className="hover:text-[#067978] transition-colors relative group cursor-pointer"
      >
        How It Works
        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#067978] transition-all group-hover:w-full" />
      </button>
      <button
        onClick={() => onNavigate('get-started')}
        className="hover:text-[#067978] transition-colors relative group cursor-pointer"
      >
        Get Started
        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#067978] transition-all group-hover:w-full" />
      </button>
      <button
        onClick={() => onNavigate('faqs')}
        className="hover:text-[#067978] transition-colors relative group cursor-pointer"
      >
        FAQs
        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#067978] transition-all group-hover:w-full" />
      </button>
    </div>
  );
};

export default NavbarLinks;
